import { Component, Injector } from '@angular/core';
import { ConfigService } from './auth/app-config.service';
import { AppConfigModel } from './auth/app-config.service.model';

@Component({
  selector: 'app-root',
  template: '',
})
export class CduiBaseComponent {
  private configService: ConfigService;
  constructor(baseInjector: Injector) {
    this.configService = baseInjector.get(ConfigService);
  }
  get api() {
    if (!this.environment.dsdOrchUrl) {
      this.environment.serverIp = '';
      this.environment.dsdOrchUrl = '/dsd-orch';
      this.environment.cdmServerAPI = '/cdm';
    }
    return this.configService.getUrls(this.environment);
  }
  get environment(): AppConfigModel {
    return this.configService.readConfig();
  }
}
